import { createSignal, Show, type Component } from "solid-js";
import { useNavigate } from "@solidjs/router";
import { LogIn } from "lucide-solid";
import { signIn } from "../lib/auth";
import { TextField, TextFieldLabel, TextFieldInput } from "../components/ui/text-field";
import { Button } from "../components/ui/Button";

const SignIn: Component = () => {
  const navigate = useNavigate();
  const [username, setUsername] = createSignal("");
  const [password, setPassword] = createSignal("");
  const [error, setError] = createSignal<string | null>(null);
  const [loading, setLoading] = createSignal(false);

  const submit = async (e: Event) => {
    e.preventDefault();
    setError(null);
    setLoading(true);
    try {
      await signIn(username().trim(), password());
      navigate("/profile");
    } catch (err) {
      setError(err instanceof Error ? err.message : "Giriş başarısız");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div class="mx-auto flex max-w-sm flex-col px-4 py-10">
      <div class="mb-6 flex items-center gap-2">
        <LogIn size={20} class="text-primary" />
        <h1 class="m-0 text-lg font-semibold">Giriş Yap</h1>
      </div>

      <form onSubmit={submit} class="flex flex-col gap-4 rounded-xl border border-border bg-card p-5">
        <TextField value={username()} onChange={setUsername} required>
          <TextFieldLabel>Kullanıcı Adı</TextFieldLabel>
          <TextFieldInput type="text" placeholder="admin" />
        </TextField>
        <TextField value={password()} onChange={setPassword} required>
          <TextFieldLabel>Şifre</TextFieldLabel>
          <TextFieldInput type="password" placeholder="admin" />
        </TextField>

        <Show when={error()}>
          <p class="m-0 text-sm text-destructive">{error()}</p>
        </Show>

        <Button type="submit" disabled={loading()}>
          {loading() ? "Giriş yapılıyor..." : "Giriş Yap"}
        </Button>

        <p class="m-0 text-center text-xs text-muted-foreground">
          Demo: <strong>admin</strong> / <strong>admin</strong>
        </p>
      </form>
    </div>
  );
};

export default SignIn;
